import { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["new", "contacted", "qualified", "closed_won", "closed_lost"];

export default function AdminSponsorLeads() {
    const [items, setItems] = useState([]);

    const load = async () => {
        const { data } = await api.get("/sponsor-leads");
        setItems(data);
    };
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try {
            await api.put(`/sponsor-leads/${id}/status?status=${status}`);
            toast.success("Updated");
            load();
        } catch (err) { toast.error(formatErr(err)); }
    };
    const del = async (id) => {
        if (!window.confirm("Delete?")) return;
        try { await api.delete(`/sponsor-leads/${id}`); load(); }
        catch (err) { toast.error(formatErr(err)); }
    };

    return (
        <div data-testid="admin-sponsor-leads">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Pipeline</div>
            <h1 className="h-display text-4xl mb-8">Sponsor Leads ({items.length})</h1>
            <div className="card-flat overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-bg-soft border-b border-line">
                        <tr>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Company</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Contact</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Tier / Budget</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Status</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((l) => (
                            <tr key={l.id} className="border-t border-line align-top" data-testid={`lead-${l.id}`}>
                                <td className="p-3">
                                    <div className="text-white">{l.company_name}</div>
                                    <div className="text-ink text-xs">{new Date(l.created_at).toLocaleDateString()}</div>
                                </td>
                                <td className="p-3 text-ink">
                                    <div>{l.contact_name}</div>
                                    <div className="text-xs">{l.email}</div>
                                    {l.phone && <div className="text-xs">{l.phone}</div>}
                                </td>
                                <td className="p-3 text-ink">
                                    <div className="uppercase text-gold text-xs tracking-widest">{l.interested_tier}</div>
                                    <div className="text-xs mt-1">{l.budget || "—"}</div>
                                    {l.message && <div className="text-xs mt-2 max-w-xs whitespace-pre-line">{l.message}</div>}
                                </td>
                                <td className="p-3">
                                    <select value={l.status} onChange={(e) => setStatus(l.id, e.target.value)} className="text-xs px-2 py-1" data-testid={`lead-status-${l.id}`}>
                                        {STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
                                    </select>
                                </td>
                                <td className="p-3 text-right">
                                    <button onClick={() => del(l.id)} className="text-red-400 text-xs uppercase">Delete</button>
                                </td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr><td colSpan={5} className="p-12 text-center text-ink">No leads yet.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
